
import { Vue, Prop, Component } from "vue-property-decorator";

@Component
export default class SelfScheduleDefaultShift extends Vue
{
    @Prop() id!: string
    @Prop() tenantId!: string;
    @Prop() facilityId!: number;
    @Prop() coid!: string;
    @Prop() facilityName!: string;
    @Prop() departmentId!: number;
    @Prop() departmentName!: string;
    @Prop() departmentCode!: string;
    @Prop() departmentShiftId!: number;
    @Prop() shiftCode!: string;
    @Prop() shiftDescription!: string;
    @Prop() skillId!: number;
    @Prop() skill!: string;
    @Prop() date!: Date;
    @Prop() startTime!: Date;
    @Prop() endTime!: Date;
    @Prop() dayOfSchedule!: number;
    @Prop() actualStartTime!: string;
    @Prop() actualEndTime!: string;
    @Prop() productiveType!: string;
    // Unavailable // TBD for this release

}
